import { Theme, darken, lighten } from "@mui/material";
import { RFC_PM } from "@utils/expreciones";

/** Monto completo del diseño (`fxMXN`): `$1,500,000`. */
export const formatMXN = (amount: number) => `$${Math.round(amount).toLocaleString("en-US")}`;

/** Formato corto del diseño (`fxM`): `$1.5M`, `$750k`, `$0`. */
export const formatShort = (amount: number) => {
  if (!amount) return "$0";
  if (amount >= 1_000_000) return `$${(amount / 1_000_000).toFixed(amount % 1_000_000 === 0 ? 0 : 1)}M`;
  return `$${Math.round(amount / 1000).toLocaleString("en-US")}k`;
};

/** Convierte lo tecleado en un monto: descarta todo lo que no sea dígito. */
export const onlyDigits = (value: string) => Number(value.replace(/[^0-9]/g, "")) || 0;

/**
 * Colores de los segmentos de cada empresa (`FXU_COLORS` del diseño), derivados de la paleta del
 * tenant para que la barra y el chip de cada fila usen el mismo color.
 */
export const getSegmentColor = (theme: Theme, index: number) => {
  const { main, accent, base } = theme.palette.primary;
  const colors = [main, lighten(main, 0.15), accent, lighten(accent, 0.35), darken(main, 0.3), base];
  return colors[index % colors.length];
};

/**
 * Error del RFC de una empresa con la que se va a operar. Es opcional: vacío no es error. Si se captura, debe ser
 * de persona moral (12 posiciones, `RFC_PM`). Primero la longitud y luego el formato, para que cada caso tenga su
 * mensaje.
 */
export const getRfcEmpresaError = (rfc: string): string => {
  const value = rfc.trim();
  if (!value) return "";
  if (value.length !== 12) return "Debe tener 12 posiciones";
  if (!RFC_PM.test(value)) return "RFC incorrecto";
  return "";
};
